// Constants
import { StoreEntityState } from "@ms/uno-constants/lib/local/StoreConstants";
import { Table } from "@ms/uno-entitycore/lib/local/table/Table";
// Slices
import { AbstractSlice } from "./AbstractSlice";
// Utilities
import { AbsentStoreEntityStatus } from "../utilities/StatusUtilities";
/**
 * A simple slice to manage creation and deletion of a collection of items.
 */ export class Slice extends AbstractSlice {
    get(id) {
        const entity = this.table().get(id);
        const status = this.statusTable.get(id) ?? AbsentStoreEntityStatus;
        return {
            data: entity,
            status
        };
    }
    getCollection(collectionDescriptor) {
        const rowIds = this.table().index(collectionDescriptor.name).partition(collectionDescriptor.value).itemIds();
        const items = [];
        for (const rowId of rowIds){
            const row = this.table().get(rowId);
            if (row) {
                // Filter out soft-deleted entities
                const entityStatus = this.statusTable.get(rowId);
                if (entityStatus?.state !== StoreEntityState.SoftDeleted) {
                    items.push(row);
                }
            }
        }
        const statusTable = this.collectionStatusTables[collectionDescriptor.name];
        const status = statusTable?.get(collectionDescriptor.value) ?? AbsentStoreEntityStatus;
        return {
            data: items,
            status
        };
    }
    createTable() {
        const table = new Table(this.name);
        for (const indexName of Object.keys(this.indexDefinitions)){
            table.registerIndex(indexName, this.indexDefinitions[indexName]);
        }
        return table;
    }
    handleInput(id, item) {
        this.table().set(id, item);
    }
    /**
     * Creates an instance of Slice
     * @param name Name of the slice
     */ constructor(name, indexDefinitions = {}){
        super(name, indexDefinitions);
    }
}
